import { DatiUtente } from "./DatiUtente"
import { TipoUtente } from "./TipoUtente"
import { AbsDatiUtente } from "./AbsDatiUtente"

export abstract class AbsUtente {
  
  private confirmed: boolean = false
  private id: number = 0
  private email!: string
  private datiUtente: DatiUtente = new DatiUtente()
  tipoUtente: TipoUtente = new TipoUtente()
  gerarchia!: number

  setUtente(dati: any) {
    this.email = dati.email
    this.id = dati.id ? dati.id : this.id
    this.confirmed = dati.confirmed
    this.tipoUtente.setTipoUtente(dati.ruoli_id, dati.ruolo, dati.gerarchia)
    this.datiUtente.setDati(dati)
    this.gerarchia = dati.gerarchia ? dati.gerarchia : this.gerarchia
  }

  setDatiUt(dati: AbsDatiUtente) {
    this.datiUtente.setDati(dati)
  }
  getID() { return this.id }
  getConfirmed() { return this.confirmed }
  getNome() { return this.datiUtente.getNome() }
  getCognome() { return this.datiUtente.getCognome() }
  getCf() { return this.datiUtente.getCf() }

  getTipoUt() { return this.tipoUtente.getTipoUtente() }
  getIDTipoUt() { return this.tipoUtente.getIdTipo() }
  getGerarchia():number { return this.tipoUtente.getGerarchia() }
  getEmail() { return this.email }
}